<template>
  <mdb-row class="vuejs-countdown" center>
    <li v-if="days > 0">
      <p class="days digit">D-{{ days | twoDigits }}</p>
    </li>
    <li>
      <p class="hours digit">{{ hours | twoDigits }}</p>
    </li>
    <a><h3  class="semicoln1">:</h3>
    </a>
    <li>
      <p class="min digit">{{ minutes | twoDigits }}</p>
    </li>
    <a><h3 class="semicoln2">:</h3>
    </a>
    <li>
      <p class="second digit">{{ seconds | twoDigits }}</p>
    </li>
  </mdb-row>
</template>

<script>
let interval = null;
export default {
  name: 'vuejsCountDown',
  props: {
    deadline: {
      type: String,
    },
    end: {
      type: String,
    },
    stop: {
      type: Boolean,
    },
  },
  data() {
    return {
      now: Math.trunc((new Date()).getTime() / 1000),
      date: null,
      diff: 0,
    };
  },
  created() {
    if (!this.deadline && !this.end) {
      throw new Error("Missing props 'deadline' or 'end'");
    }

    const endTime = this.deadline ? this.deadline : this.end;
    this.date = Math.trunc(Date.parse(endTime.replace(/-/g, '/')) / 1000);

    if (!this.date) {
      throw new Error("Invalid props value, correct the 'deadline' or 'end'");
    }

    interval = setInterval(() => {
      this.now = Math.trunc((new Date()).getTime() / 1000);
    }, 1000);
  },
  computed: {
    seconds() {
      return Math.trunc(this.diff) % 60;
    },
    minutes() {
      return Math.trunc(this.diff / 60) % 60;
    },
    hours() {
      return Math.trunc(this.diff / 60 / 60) % 24;
    },
    days() {
      return Math.trunc(this.diff / 60 / 60 / 24);
    },
  },
  watch: {
    now() {
      this.diff = this.date - this.now;
      if (this.diff <= 0 || this.stop) {
        this.diff = 0;
        // Remove interval
        clearInterval(interval);
      }
    },
  },
  filters: {
    twoDigits(value) {
      if (value.toString().length <= 1) {
        return `0${value.toString()}`;
      }
      return value.toString();
    },
  },
  destroyed() {
    clearInterval(interval);
  },
};
</script>

<style>
.vuejs-countdown {
  max-width: 250px;
  margin-left:  -3%;
}

.semicoln1 {
  margin-right: 3px;
  color: black;
}

.semicoln2 {
  margin-right: 3px;
  color: black;
}

.days {
  font-size: 20px;
  color: black;
  padding: 0 10px;
  background-color: #ffba00;
  background-size: 100% 100%;
  margin-right: 20px;
  top: 0px;
}

.hours {
  position: relative;
  width: 40px;
  font-size: 20px;
  color: #ffffff;
  background-color: black;
  background-size: 100% 100%;
}

.min {
  position: relative;
  width: 40px;
  font-size: 20px;
  color: #ffffff;
  background-color: black;
  background-size: 100% 100%;
}

.second {
  position: relative;
  width: 40px;
  font-size: 20px;
  color: #ffffff;
  background-color: black;
  background-size: 100% 100%;
}

.vuejs-countdown li {
  display: inline-block;
  text-align: center;
}

.vuejs-countdown li:after {
  font-size: 23px;
}

.vuejs-countdown .digit {
  font-size: 23px;
  font-weight: 600;
  line-height: 1.4;
}

.vuejs-countdown .text {
  text-transform: uppercase;
  font-size: 10px;
}
</style>
